import { render } from "./Maintenance.vue?vue&type=template&id=0d2e9042&scoped=true"
const script = {}

import "./Maintenance.vue?vue&type=style&index=0&id=0d2e9042&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0d2e9042"

export default script